var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDivider,
            expression: "showDivider"
          }
        ],
        staticClass: "divider"
      },
      [
        _c("div", {
          staticStyle: {
            width: "calc(100% - 0.2rem - 0.2rem)",
            height: "100%",
            margin: "0 auto",
            background: "#d9d9d9"
          }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { class: ["tabs-box", _vm.align == "right" ? "right" : ""] },
      _vm._l(_vm.tabs, function(title, index) {
        return _c(
          "div",
          {
            key: index,
            class: ["title", _vm.currentTab == title ? "currentTab" : "tab"],
            style: _vm.cssStyle,
            on: {
              click: function($event) {
                return _vm.handleEvent(title)
              }
            }
          },
          [_vm._v("\n        " + _vm._s(title) + "\n      ")]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0a17312", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0a17312","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXTabs/index.vue
// module id = 505
// module chunks = 0